import { Box, Typography } from '@mui/material';
import { FC, memo } from 'react';
import { EmployeeDto, ScheduleRespondentAnswerDto, WorkItemDescriptionDisplayMode } from '../../../../dtos';
import { FormInput } from '../../../CoreLib/library';
import { BusinessComponentLabel } from './BusinessComponentLabel';

interface BusinessComponentNameIdPair {
    name: string;
    id: string;
    description?: string;
    descriptionDisplayMode?: WorkItemDescriptionDisplayMode;
}

export interface IBCMSurveyRowProps {
    key: string;
    businessComponent: BusinessComponentNameIdPair;
    respondent: EmployeeDto;
    researchActivityEntry: ScheduleRespondentAnswerDto;
    informationSoughtEntry: ScheduleRespondentAnswerDto;
    disabled?: boolean;
    setQuestionAnswer: (fieldName: string, value: string | number) => void;
    isPdfView?: boolean;
};

export const BCMSurveyRow: FC<IBCMSurveyRowProps> = memo(({
    key,
    businessComponent,
    respondent,
    researchActivityEntry,
    informationSoughtEntry,
    disabled,
    setQuestionAnswer,
    isPdfView,
}) => {
    return (
        <Box key={key} sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', py: 2 }} className={!isPdfView ? "standard-survey-form-row" : undefined}>
            <Box sx={{ flex: '0 0 27.5%' }}>
                <BusinessComponentLabel bcInfo={{ name: businessComponent.name, description: businessComponent.description ?? '', displayMode: businessComponent.descriptionDisplayMode ?? WorkItemDescriptionDisplayMode.Hide }} isBCMTaker={true} />
            </Box>
            <Box sx={{ flex: '0 0 27.5%' }}>
                <Typography>{respondent.name}</Typography>
            </Box>
            <Box sx={{ flex: '0 0 27.5%' }}>
                <FormInput
                    label={''}
                    value={researchActivityEntry.answerValue.toString()}
                    onChange={(event) => setQuestionAnswer(researchActivityEntry.fieldKey, event.target.value)}
                    inputProps={{ className: 'standard-outlined-input' }}
                    fullWidth
                    disabled={disabled}
                />
            </Box>
            <Box sx={{ flex: '1 1 0' }}>
                <FormInput
                    label={''}
                    value={informationSoughtEntry.answerValue.toString()}
                    onChange={(event) => setQuestionAnswer(informationSoughtEntry.fieldKey, event.target.value)}
                    inputProps={{ className: 'standard-outlined-input' }}
                    fullWidth
                    disabled={disabled}
                />
            </Box>
        </Box>
    );
});